export default {
    productionLines: [],    // Factory Structure
    stations:[],
    machines:[],
    machineOperationPivots:[],
    operationGroups: [],    //N
    operations: [],         //N
    referenceGroups:[],     //N
    references:[],          //N
    magnitudeUnits:[],
    packagings:[],
    packagingFormats:[],
    modals:[],
    userPermissions:[],
    isUserSuperadmin: false,
    isUserAdmin: false,
    username: '',
}
